import { logger } from '../../../utils/logger'
import { DatePipe } from '@angular/common'
import { Component, OnInit, ViewChild, DestroyRef, inject } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { ComissaoJulgadoraService } from '../comissao-julgadora-service'
import { ActivatedRoute, Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog';
import { ComissaoResultadoInscricaoDTO, ResultadoClassificacaoLinha } from 'src/app/models/ComissaoResultadoInscricaoDTO'
import { ConceitoJustificativaDialogComponent } from '../lista-classificacao-examinador/justificativa-dialog/conceito-justificativa-dialog.component'
import { JustificativaInfoDialogComponent } from '../lista-classificacao-examinador/justificativa-info-dialog/justificativa-info-dialog.component'
import { ArquivoViewerDialogComponent } from '../../arquivo-viewer-dialog/arquivo-viewer-dialog.component';
import { firstValueFrom } from 'rxjs';
import { AndamentoService } from 'src/app/services/andamento.service'
import { VisualizarClassificacaoFase1Component } from '../visualizar-classificacao-fase1/visualizar-classificacao-fase1.component'
import { VisualizarClassificacaoIterativaComponent } from '../visualizar-classificacao-iterativa/visualizar-classificacao-iterativa.component'
import { trigger, state, style, transition, animate } from '@angular/animations';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

const JUSTIFICATIVA_EMPATE_TECNICO = 'Empate técnico - não foi possível desempatar pelas regras estabelecidas'

@Component({
  selector: 'inscricoes-lista-prova-examinador-unicamp',
  templateUrl: './lista-classificacao-presidente.component.html',
  styleUrls: ['./lista-classificacao-presidente.component.scss'],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class ListaClassificacaoPresidenteComponent implements OnInit {
  private destroyRef = inject(DestroyRef)

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasClassificacaoGrid: string[] = [];
  colunasGrid: string[] = [
    'classificacao',
    'inscricaoId',
    'nome',
    'nascimento',    
    'conceito',
    'indicacoes'
  ];

   colunasFase1Grid: string[] = [
    'classificacao',
    'inscricaoId',
    'nome',
    'nascimento',
    'mediaFinal'
  ];
  
  dataSource: MatTableDataSource<ComissaoResultadoInscricaoDTO> = new MatTableDataSource()
  dataSourceFiltrado: MatTableDataSource<ComissaoResultadoInscricaoDTO> = new MatTableDataSource()
  dataSourceFase1: MatTableDataSource<ComissaoResultadoInscricaoDTO> = new MatTableDataSource()
  dataSourceClassificacao: MatTableDataSource<ResultadoClassificacaoLinha> = new MatTableDataSource()
  datepipe: DatePipe = new DatePipe('pt-BR')
  concursoId: number = 0;
  retificado: boolean = false;
  headerRow: string[] = [];  
  exibirBotaoConsolidar: boolean = false;
  exibirBotaoConsolidarFase1: boolean = false;
  mappedData: any[] = [];
  exibirBotaoVisualizarFase1: boolean = false;
  mappedDataFase1: any[] = [];
  isConsolidando = false;
  isExaminadorView: boolean = false;
  
  tiposProva: string[] = [];
  tipoProvaSelecionado: string = '';
  notasPorTipo: { [key: string]: any[] } = {};
  colunasPorTipo: { [key: string]: string[] } = {};
  examinadoresInfo: { [key: string]: { name: string, comissaoId: string, matricula?: string } } = {};
  comissoesInfo: { [key: string]: { nome: string, matricula?: string } } = {};
  tipoClassificacao: 'todos' | 'pcd' = 'todos';
  tipoConcurso: string = '';
  instrucoesExpandidas: boolean = false;
  private _processandoConceito = false;

  constructor(
    private router: Router,
    private unespCoreMessageService: UnespCoreMessageService,
    private route: ActivatedRoute,
    private comissaoJulgadoraService: ComissaoJulgadoraService,
    public dialog: MatDialog,
    private andamentoService: AndamentoService
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.isExaminadorView = params['examinador'] === 'true';
    });
    this.loadData();    
  }

  loadData() {
    this.concursoId = Number(this.route.snapshot.paramMap.get('concursoId'));
  
    if (!this.concursoId) {
      this.unespCoreMessageService.showMessageError('Concurso não encontrado na rota.');
      return;
    }

    this.andamentoService.possuiRecursoDeferidoResultadoFinal(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(r => this.retificado = r)

    this.loadResumoNotas();
  
    // Examinador visualiza classificação consolidada (fase 2)
    if (this.isExaminadorView) {
      this.comissaoJulgadoraService.obterClassificacaoFase2(this.concursoId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (data: any) => {
            this.processarDadosClassificacao(data);
          },
          error: (err) => {
            this.unespCoreMessageService.showMessageError(
              err?.error?.message ?? 'Erro ao carregar a classificação da Fase 2.'
            );
          }
        });
    } else {
      // Presidente consolida resultado final
      this.comissaoJulgadoraService.getResultadoFinal(this.concursoId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (data: any) => {
            this.processarDadosClassificacao(data);
          },
          error: (err) => {
            this.unespCoreMessageService.showMessageError(
              err?.error?.message ?? 'Erro ao carregar resultado final.'
            );
          }
        });
    }
  }

  processarDadosClassificacao(data: any) {
    // Extrai o tipo de concurso do primeiro item
    if (data.length > 0 && data[0].tipoConcurso) {
      this.tipoConcurso = data[0].tipoConcurso;
    }

    const dadosFase2 = data.filter((item: any) => item.fase === 'FASE2');
    const dadosFase1 = data.filter((item: any) => item.fase === 'FASE1');

    this.mappedData = dadosFase2.map((item: any, index: number) => {
            const nascimento = item.nascimento;
            const idade = this.calcularIdade(nascimento);

            return {
              resultadoId: item.resultadoId,
              classificacao: index + 1,
              inscricaoId: item.inscricaoId,
              conceito: item.conceito,
              nome: item.nome,
              nomeSocial: item.nomeSocial,
              estaEmpatado: item.estaEmpatado,
              estaEliminado: item.estaEliminado,
              existeClassificacao: item.existeClassificacao,
              conceitoAnterior: item.conceitoAnterior,
              justificativa: item.justificativa,
              fase: item.fase,
              posicaoMaisRecorrente: item.posicaoMaisRecorrente,
              quantidadeNaPosicaoMaisRecorrente: item.quantidadeNaPosicaoMaisRecorrente,
              nascimento: this.formatarData(nascimento) + ` (${idade} anos)`,
              idade: idade,
              mediaFinal: item.mediaFinal,
              resultados: item.resultados,
              PCD: item.PCD,
              jurado : item.jurado,
              documentoJuradoInvalido: item.documentoJuradoInvalido
            };
          });

          this.mappedDataFase1 = dadosFase1.map((item: any, index: number) => {
            const nascimento = item.nascimento;
            const idade = this.calcularIdade(nascimento);

            return {
              resultadoId: item.resultadoId,
              classificacao: index + 1,
              inscricaoId: item.inscricaoId,
              conceito: item.conceito,
              nome: item.nome,
              nomeSocial: item.nomeSocial,
              estaEmpatado: item.estaEmpatado,
              estaEliminado: item.estaEliminado,
              existeClassificacao: item.existeClassificacao,
              conceitoAnterior: item.conceitoAnterior,
              justificativa: item.justificativa,
              fase: item.fase,
              posicaoMaisRecorrente: item.posicaoMaisRecorrente,
              quantidadeNaPosicaoMaisRecorrente: item.quantidadeNaPosicaoMaisRecorrente,
              nascimento: this.formatarData(nascimento) + ` (${idade} anos)`,
              idade: idade,
              mediaFinal: item.mediaFinal,
              resultados: item.resultados,
              PCD: item.PCD,
              jurado : item.jurado,
              documentoJuradoInvalido: item.documentoJuradoInvalido
            };
          });

          // Encontra a média do 8º colocado
          const oitavo = this.mappedDataFase1.find(item => item.classificacao === 8);
          const mediaOitavo = oitavo?.mediaFinal;

          // Marca quem está eliminado (posição > 8 e média diferente da do oitavo)
          this.mappedDataFase1 = this.mappedDataFase1.map(item => {
            const eliminado = item.classificacao > 8 && item.mediaFinal !== mediaOitavo;
            return { ...item, eliminado };
          });

          this.exibirBotaoConsolidarFase1 = this.mappedDataFase1.some((item: any) =>
            item.resultados?.some((r: any) => !r.classificacaoData)
          );

          this.exibirBotaoConsolidar = this.mappedData.some((item: any) =>
            item.resultados?.some((r: any) => !r.classificacaoPosicao)
          );

          // Verifica se deve exibir o botão de visualizar Fase 1
          this.exibirBotaoVisualizarFase1 = dadosFase2.length > 0;

          logger.log(this.mappedDataFase1);
  
          this.dataSource.data = this.mappedData;
          this.dataSourceFase1.data = this.mappedDataFase1;
          this.atualizarDataSourceFiltrado();
          this.loadClassificacao(this.mappedData);
  }

  loadResumoNotas() {
    this.comissaoJulgadoraService.buscarResumoNotasPresidente(this.concursoId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.processarResumoNotas(data);
        },
        error: (err) => {
          console.error('Erro ao carregar resumo das notas:', err);
        }
      });
  }

  processarResumoNotas(data: any[]) {
    this.tiposProva = [...new Set(data.map(item => item.tipoProva))].sort();
    
    // Mapear informações das comissões por comissaoJulgadoraId
    data.forEach(item => {
      if (item.nomeComissaoJulgadora && item.comissaoJulgadoraId) {
        this.comissoesInfo[item.comissaoJulgadoraId] = {
          nome: item.nomeComissaoJulgadora,
          matricula: item.matriculaComissaoJulgadora
        };
      }
    });
    
    this.tiposProva.forEach(tipo => {
      const notasTipo = data.filter(item => item.tipoProva === tipo);
      const comissaoIds = [...new Set(notasTipo.map(item => String(item.comissaoJulgadoraId)))].sort();
      
      this.colunasPorTipo[tipo] = ['inscricaoId', 'nome', ...comissaoIds];
      
      const candidatos = [...new Set(notasTipo.map(item => item.inscricaoId))];
      this.notasPorTipo[tipo] = candidatos.map(inscricaoId => {
        const candidato = notasTipo.find(n => n.inscricaoId === inscricaoId);
        const linha: any = {
          inscricaoId,
          nome: candidato?.nome,
          nomeSocial: candidato?.nomeSocial
        };
        
        comissaoIds.forEach(comissaoId => {
          const nota = notasTipo.find(n => n.inscricaoId === inscricaoId && String(n.comissaoJulgadoraId) === comissaoId);
          linha[comissaoId] = nota?.nota !== undefined ? nota.nota : '-';
        });
        
        return linha;
      });
    });
  }

  selecionarTipoProva(tipo: string) {
    this.tipoProvaSelecionado = this.tipoProvaSelecionado === tipo ? '' : tipo;
  }

  loadClassificacao(dados: any[]) {
    const examinadores = Array.from(
      new Set(
        dados.flatMap(item => item.resultados.map((r: any) => String(r.comissaoId)))
      )
    ).sort();
  
    // Mapear informações dos examinadores
    examinadores.forEach(comissaoId => {
      const examinadorData = dados.flatMap(item => item.resultados)
        .find((r: any) => String(r.comissaoId) === comissaoId);
      if (examinadorData) {
        this.examinadoresInfo[comissaoId] = {
          name: examinadorData.examinadorNome,
          comissaoId: String(examinadorData.comissaoId),
          matricula: examinadorData.examinadorMatricula
        };
      }
    });
  
    this.colunasClassificacaoGrid = ['posicao', ...examinadores];
  
    this.headerRow = ['posicao'];
    examinadores.forEach(comissaoId => {
      this.headerRow.push(`${comissaoId}_nome`, `${comissaoId}_media`, `${comissaoId}_conceito`);
    });
  
    const posicoes = Array.from(
      new Set(
        dados.flatMap(item => item.resultados.map((r: any) => r.posicao))
      )
    ).sort((a, b) => a - b);
  
    this.dataSourceClassificacao.data = posicoes.map(pos => {
      const linha: ResultadoClassificacaoLinha = { posicao: pos };
      examinadores.forEach(examinador => {
        const registro = dados.find(item =>
          item.resultados.some(
            (r: any) => r.posicao === pos && String(r.comissaoId) === examinador
          )
        );
  
        const candidato = registro?.resultados.find(
          (r: any) => r.posicao === pos && String(r.comissaoId) === examinador
        );
  
        linha[`${examinador}_nome`] = candidato ? candidato.inscricaoNome : '-';
        linha[`${examinador}_nomeSocial`] = candidato ? candidato.inscricaoNomeSocial : '-';
        linha[`${examinador}_media`] = candidato ? (candidato.mediaFinal?.toFixed(2) ?? '-') : '-';
        linha[`${examinador}_conceito`] = candidato?.conceito || '';
        linha[`${examinador}_justificativa`] = candidato?.justificativa || '';
      });

      return linha;
    });
  }  

  enviarConceito(row: ComissaoResultadoInscricaoDTO) {
    if (this._processandoConceito) return;
    if (row.conceitoAnterior == row.conceito) return;
  
    const conceito = (row.conceito || '').trim().toUpperCase();

    // Limpar conceito (valor vazio): envia direto ao backend sem justificativa
    if (!conceito) {
      if (!row.conceitoAnterior) return;
      const payload = { conceito: '', justificativa: JUSTIFICATIVA_EMPATE_TECNICO };
      this.comissaoJulgadoraService.atualizarConceitoPresidente(row.resultadoId, payload).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          this.unespCoreMessageService.showMessageSuccess('Conceito removido.');
          this.loadData();
        },
        error: (err) => {
          row.conceito = row.conceitoAnterior ?? undefined;
          const message = err?.error?.message || 'Erro ao remover conceito.';
          this.unespCoreMessageService.showMessageError(message);
        },
      });
      return;
    }
  
    if (conceito.length !== 1 || !/^[A-Z]$/.test(conceito)) {
      this.unespCoreMessageService.showMessageError('Informe uma letra válida (A-Z) para o conceito.');
      row.conceito = row.conceitoAnterior ?? undefined;
      return;
    }
    
    // Filtra todos os candidatos empatados (incluindo o atual)
    const candidatosEmpatados = this.dataSource.data.filter(
      r => r.estaEmpatado && 
           r.posicaoMaisRecorrente === row.posicaoMaisRecorrente && 
           r.quantidadeNaPosicaoMaisRecorrente === row.quantidadeNaPosicaoMaisRecorrente
    );

    // Valida se o conceito está dentro do limite permitido
    const totalEmpatados = candidatosEmpatados.length;
    const letraMaximaPermitida = String.fromCharCode(64 + totalEmpatados); // A=65, então 64+1=A
    
    if (conceito > letraMaximaPermitida) {
      this.unespCoreMessageService.showMessageError(
        `Existem apenas ${totalEmpatados} candidato(s) empatado(s) com esta nota. ` +
        `Os conceitos permitidos são de A até ${letraMaximaPermitida}.`,
        'Fechar'
      );
      row.conceito = row.conceitoAnterior ?? undefined;
      return;
    }

    const conceitoJaUsado = candidatosEmpatados.some(
      r => r !== row && r.conceito?.trim()?.toUpperCase() === conceito
    );

    if (conceitoJaUsado) {
      this.unespCoreMessageService.showMessageError(
        `O conceito '${conceito}' já foi atribuído para outro candidato com a mesma nota.`,
        'Fechar'        
      );      
      row.conceito = row.conceitoAnterior ?? undefined;
      return;
    }
  
    this._processandoConceito = true;
    const dialogRef = this.dialog.open(ConceitoJustificativaDialogComponent, {
      width: '1000px',
      data: { nome: row.nome, itemEdital: '11.8.1' },
      disableClose: true
    });
  
    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((justificativa: string) => {
      this._processandoConceito = false;
      if (!justificativa) {
        row.conceito = row.conceitoAnterior ?? undefined;
        return;
      }
  
      const payload = { conceito, justificativa };
  
      this.comissaoJulgadoraService.atualizarConceitoPresidente(row.resultadoId, payload).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          this.unespCoreMessageService.showMessageSuccess('Conceito atualizado com sucesso.');
          this.loadData();
        },
        error: (err) => {
          row.conceito = row.conceitoAnterior ?? undefined;
          const message = err?.error?.message || 'Erro ao atualizar conceito.';
          this.unespCoreMessageService.showMessageError(message);
          console.error(err);
        },
      });
    });
  }

  consolidarClassificacao() {
    const notas = this.dataSource.data;
  
    if (notas.length === 0) {
      this.unespCoreMessageService.showMessageError('Não há inscrições para enviar.');
      return;
    }
  
    this.isConsolidando = true;
  
    this.comissaoJulgadoraService.consolidarClassificacao(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.unespCoreMessageService.showMessageSuccess('Classificação gerada com sucesso.');
        setTimeout(() => window.location.reload(), 1500);
      },
      error: (erro) => {
        this.unespCoreMessageService.showMessageError(
          erro?.error?.message ?? 'Erro ao gerar classificação.'
        );
        this.isConsolidando = false;
      }
    });
  }

  consolidarClassificacaoFase1() {
    const notas = this.dataSourceFase1.data;
  
    if (notas.length === 0) {
      this.unespCoreMessageService.showMessageError('Não há inscrições para enviar.');
      return;
    }
  
    this.isConsolidando = true;
  
    this.comissaoJulgadoraService.consolidarClassificacaoFase1(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.unespCoreMessageService.showMessageSuccess('Classificação gerada com sucesso.');
        this.router.navigate([`/comissao-julgadora/listar-provas`, this.concursoId]);
      },
      error: (erro) => {
        this.unespCoreMessageService.showMessageError(
          erro?.error?.message ?? 'Erro ao gerar classificação.'
        );
        this.isConsolidando = false;
      }
    });
  }

  getClassificacaoInfo(): { usuario: string, data: string } | null {
    for (const item of this.mappedData) {
      for (const resultado of item.resultados || []) {
        if (resultado.classificacaoPosicao) {
          return {
            usuario: resultado.classificacaoUsuario,
            data: resultado.classificacaoData
          };
        }
      }
    }
    return null;
  }

  formatarData(dataStr: string): string {
    const data = new Date(dataStr);
    return this.datepipe.transform(data, 'dd/MM/yyyy') ?? '';
  }

  calcularIdade(dataStr: string): number {
    const nascimento = new Date(dataStr);
    const hoje = new Date();
  
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();
  
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }
  
    return idade;
  }

  permitirSomenteLetra(event: KeyboardEvent) {
    const char = event.key;
    const regex = /^[a-zA-Z]$/;
    if (!regex.test(char)) {
      event.preventDefault();
    }
  }

  mostrarJustificativa(justificativa: string) {
    this.dialog.open(JustificativaInfoDialogComponent, {
      width: '400px',
      data: { justificativa }
    });
  }

  getExaminadorDisplayName(comissaoId: string): string {
    return this.examinadoresInfo[comissaoId]?.name || comissaoId;
  }

  getExaminadorMatricula(comissaoId: string): string {
    return this.examinadoresInfo[comissaoId]?.matricula || '';
  }

  getComissaoMatricula(comissaoId: string): string | undefined {
    return this.comissoesInfo[comissaoId]?.matricula;
  }

  getComissaoNome(comissaoId: string): string {
    return this.comissoesInfo[comissaoId]?.nome || comissaoId;
  }

  selecionarTipoClassificacao(tipo: 'todos' | 'pcd') {
    this.tipoClassificacao = tipo;
    this.atualizarDataSourceFiltrado();
  }

  atualizarDataSourceFiltrado() {
    let dadosFiltrados = this.dataSource.data;
    
    if (this.tipoClassificacao === 'pcd') {
      dadosFiltrados = this.dataSource.data
        .filter(item => item.PCD === true)
        .map((item, index) => ({ ...item, classificacao: index + 1 }));
    }
    
    this.dataSourceFiltrado.data = dadosFiltrados;
  }

  exibirIconePCD(): boolean {
    return this.tipoConcurso !== 'PTPP';
  }

  async visualizarDocumentoJurado(inscricaoId: number): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.comissaoJulgadoraService.downloadDocumentoComplementarJurado(inscricaoId)
      );
      
      const url = URL.createObjectURL(response);
      const titulo = `Documento do Jurado - Inscrição #${inscricaoId}`;
      
      this.dialog.open(ArquivoViewerDialogComponent, {
        data: { tituloDoArquivo: titulo, urlDoArquivo: url },
        width: '98vw',
        height: '96vh',
        maxWidth: '100vw',
        panelClass: 'fullheight-dialog',
      });
    } catch (error) {
      this.unespCoreMessageService.showMessageError(
        'Erro ao carregar documento do jurado. Verifique se o arquivo existe.'
      );
      console.error('Erro no download:', error);
    }
  }

  voltar(): void {
    this.router.navigate(['/comissao-julgadora/listar-provas', this.concursoId]);
  }

  existemEmpatesNaoResolvidos(): boolean {
    return this.dataSource.data.some(row => row.estaEmpatado && !row.conceito);
  }

  toggleInstrucoes(): void {
    this.instrucoesExpandidas = !this.instrucoesExpandidas;
  }

  visualizarClassificacaoFase1(): void {
    this.comissaoJulgadoraService.getClassificacaoFase1(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (classificacao) => {
        this.comissaoJulgadoraService.buscarResumoNotasPresidente(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
          next: (resumoNotas) => {
            const dadosFase1 = resumoNotas.filter(item => item.fase === 'FASE1');
            this.dialog.open(VisualizarClassificacaoFase1Component, {
              width: '90%',
              maxWidth: '1200px',
              data: { classificacao, resumoNotas: dadosFase1 }
            });
          },
          error: (err) => {
            this.unespCoreMessageService.showMessageError(
              err?.error?.message ?? 'Erro ao carregar resumo das notas da Fase 1.'
            );
          }
        });
      },
      error: (err) => {
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao carregar classificação da Fase 1.'
        );
      }
    });
  }

  visualizarClassificacaoIterativa(): void {
    this.comissaoJulgadoraService.getClassificacaoPassos(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (dados) => {
        this.dialog.open(VisualizarClassificacaoIterativaComponent, {
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          panelClass: 'fullscreen-dialog',
          data: { dados }
        });
      },
      error: (err) => {
        this.unespCoreMessageService.showMessageError(
          err?.error?.message ?? 'Erro ao carregar os passos da classificação iterativa.'
        );
      }
    });
  }
}
